module.exports = __webpack_public_path__ + "media/img/illustrations/icons/badge-agency-17f64299eda5c383b49212e5aaa63db2.svg";